import React, { Component } from 'react';
import { ListGroup, ListGroupItem, Card, Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { fetchData, userSelection, questionSelection,
    broadcastMessageChange, messageTitleChange, pushMessage,
    broadcastMessageClear, clearBroadcastText } from '../../actions/ChatList/ChatListActions';
import { connect } from 'react-redux';
import '../../App.css';
import Moment from 'moment';
import { logout } from './../../actions/Auth/UserLoginCheck';
import { Link } from 'react-router';
import Header from './../common/Header';
import Loader from './../common/Loader';

class Chat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            modal: false
        };

        this.toggle = this.toggle.bind(this);
    }

    componentWillMount() {
        const { users } = this.props;
        this.props.fetchData(users);
        this.props.clearBroadcastText();
    }

    componentDidMount() {
        setTimeout(() => this.setState({ loading: false }), 500);
    }

    onBroadcastMessageChange(event) {
        this.props.broadcastMessageChange(event);
    }

    onMessageTitleChange(event) {
        this.props.messageTitleChange(event);
    }

    onTouch(user) {
        this.props.userSelection(user);
    }

    onTouchQuestion(question, users) {
        this.props.questionSelection(question, users);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    logoutButtonPress() {
        const { users } = this.props;
        this.props.logout({ users });
    }


    formatTime(val) {
        return (
            <span style={{ fontFamily: 'Source Sans Pro', fontSize: 14 }}>
                {Moment(val).format('DD MMM YYYY')}, {Moment(val).format('kk:mm')}
            </span>
        );
    }

    renderActiveUser(list) {
        if (this.props.user === '') {
           if (list.user.name === this.props.data[0].user.name) {   //shows the 1st user name as active if no user selected
               return (
                   <ListGroupItem style={styles.activeUserStyle}>
                       {list.user.name}
                   </ListGroupItem>
               );
           } else {
               return (
                   <ListGroupItem style={styles.inactiveUserStyle}>
                       {list.user.name}
                   </ListGroupItem>
               );
           }
        } else {
            if (list.user.name === this.props.user.user.name) {    //shows the selected user name as active
                return (
                    <ListGroupItem style={styles.activeUserStyle}>
                        {list.user.name}
                    </ListGroupItem>
                );
            } else {
                return (
                    <ListGroupItem style={styles.inactiveUserStyle}>
                        {list.user.name}
                    </ListGroupItem>
                );
            }
        }
    }

    renderList() {
        return this.props.data.map((list) => {
            return (
                <Link to="/Chat" onClick={this.onTouch.bind(this, list)} key={list.user.name} style={{ textDecoration: 'none' }}>
                    {this.renderActiveUser(list)}
                </Link>
            );
        });
    }

    renderChatList() {
        return (
            <div>
               <ListGroup>
                    {this.renderList()}
               </ListGroup>
            </div>
        );
    }

    renderQuestions() {
        const { users } = this.props;
        if (this.props.user === '') {     //shows the 1st user name data if no user selected
           return this.props.data
                .filter((user, index) => index === 0)
                .map((user) => {
                return user.questions.map((question, index) => {
                    return (
                        <div key={index} style={{ padding: 10 }}>
                            <Link to="/Chat/Answers" onClick={this.onTouchQuestion.bind(this, question, users)} style={{ textDecoration: 'none' }}>
                                <Card style={styles.cardStyle}>
                                    <span style={styles.questionStyle}>
                                        {question.question}
                                    </span>
                                    <div className="row" style={{ padding: 10 }}>
                                        <div className="col-md-6 col-xs-6">
                                           <span style={styles.userNameStyle}>
                                               {this.formatTime(question.asked_on)}
                                           </span>
                                        </div>
                                        <div className="col-md-6 col-xs-6" style={{ textAlign: 'center' }}>
                                           <span style={styles.userNameStyle}>
                                               {user.user.name}
                                           </span>
                                        </div>
                                    </div>
                                </Card>
                            </Link>
                        </div>
                    );
                });
            });
        } else {
            return this.props.user.questions.map((question, index) => {        //shows the selected user name data 
                return (
                    <div key={index} style={{ padding: 10 }}>
                        <Link to="/Chat/Answers" onClick={this.onTouchQuestion.bind(this, question, users)} style={{ textDecoration: 'none' }}>
                            <Card style={styles.cardStyle}>
                                <span style={styles.questionStyle}>
                                    {question.question}
                                </span>
                                <div className="row" style={{ padding: 10 }}>
                                    <div className="col-md-6 col-xs-6">
                                           <span style={styles.userNameStyle}>
                                               {this.formatTime(question.asked_on)}
                                           </span>
                                    </div>
                                    <div className="col-md-6 col-xs-6" style={{ textAlign: 'center' }}>
                                           <span style={styles.userNameStyle}>
                                               {this.props.user.user.name}
                                           </span>
                                    </div>
                                </div>
                            </Card>
                        </Link>
                    </div>
                );
            });
        }
    }

    render() {
        const { loading } = this.state;
        const { users } = this.props;
        return (
            <div style={{ overflowX: 'hidden', overflowY: 'hidden', height: '100vh' }}>
                <Header />
                {
                    loading === true ? <Loader /> :
                        <div className="row">
                            <div className="col-xs-6 col-md-4">
                                <div style={{ padding: 25, overflowX: 'hidden', overflowY: 'scroll', height: '90vh' }}>
                                    <div className="row" style={{ paddingBottom: 10 }}>
                                        <div className="col" />
                                        <div className="col">
                                            <Button
                                                style={styles.broadcastMessageButtonStyle}
                                                onClick={this.toggle}
                                            >
                                                <span style={{ fontSize: 15 }}>
                                                   Broadcast Message
                                                </span>
                                            </Button>
                                            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                                                <ModalHeader toggle={this.toggle}>Message Box</ModalHeader>
                                                <ModalBody>
                                                    <input
                                                        style={styles.inputStyle}
                                                        placeholder="Enter Title"
                                                        value={this.props.messageTitle}
                                                        onChange={event => this.onMessageTitleChange(event.target.value)}
                                                    />
                                                    <div style={{ paddingTop: 15 }}>
                                                        <textarea
                                                            rows="5"
                                                            placeholder="Enter Your Message"
                                                            style={styles.textAreaStyle}
                                                            value={this.props.broadcastText}
                                                            onChange={event => this.onBroadcastMessageChange(event.target.value)}
                                                        />
                                                    </div>
                                                </ModalBody>
                                                <ModalFooter>
                                                    {
                                                        this.props.messageTitle.length === 0 || this.props.broadcastText.length === 0 ?
                                                            <button type="button" className="btn btn-default" disabled="disabled">
                                                                Push
                                                            </button> :
                                                            <Button
                                                                style={styles.pushMessageButtonStyle}
                                                                onClick={() => {
                                                           this.props.pushMessage(users, this.props.messageTitle, this.props.broadcastText);
                                                           this.props.broadcastMessageClear();
                                                           this.toggle();
                                                        }}
                                                            >
                                                                Push
                                                            </Button>
                                                    }
                                                </ModalFooter>
                                            </Modal>
                                        </div>
                                    </div>
                                    {this.renderChatList()}
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-8">
                                <div style={{ padding: 40, overflowX: 'hidden', overflowY: 'scroll', height: '90vh' }}>
                                    {this.renderQuestions()}
                                </div>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

const styles = {
    inputStyle: {
        width: '100%',
        height: 40,
        paddingLeft: 20,
        borderRadius: '4px',
        borderColor: '#ced4da',
        borderTopColor: '#ced4da',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0,
        borderWidth: '0.5px'
    },
    textAreaStyle: {
        width: '100%',
        paddingLeft: 20,
        paddingRight: 20,
        borderRadius: '4px',
        borderColor: '#9b9b9b',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0
    },
    cardStyle: {
        margin: 'auto',
        width: '75%',
        borderLeftColor: '#7ed321',
        borderLeftWidth: 15,
        boxShadow: `0px 0px 15px 0px rgba(0,0,0,0.05)`,
        borderRadius: 10
    },
    activeUserStyle: {
        boxShadow: `0px 0px 15px 0px rgba(0,0,0,0.05)`,
        backgroundColor: '#eefedb',
        borderColor: '#7ed321',
        color: '#000',
        margin: 10,
        fontFamily: 'Source Sans Pro-SemiBold',
        padding: 10
    },
    inactiveUserStyle: {
        color: '#000',
        margin: 10,
        fontFamily: 'Source Sans Pro-SemiBold',
        padding: 10
    },
    questionStyle: {
        color: '#000',
        fontFamily: 'Source Sans Pro-SemiBold',
        padding: 5,
        paddingLeft: 10
    },
    userNameStyle: {
        fontFamily: 'Source Sans Pro',
        color: '#9b9b9b'
    },
    broadcastMessageButtonStyle: {
        backgroundColor: '#fff',
        borderWidth: 1,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`,
        color: '#40b508',
        borderColor: '#40b508'
    },
    pushMessageButtonStyle: {
        backgroundColor: '#40b508',
        borderWidth: 0,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    }
};

function mapStateToProps(state) {
    return {
        data: state.list.data,
        user: state.list.selectedUser,
        answer: state.list.selectedQuestion,
        users: state.login.user,
        broadcastText: state.list.broadcastText,
        messageTitle: state.list.messageTitle,
        emailLogin: state.login.email,
        passwordLogin: state.login.password
    };
}

export default connect(mapStateToProps, {
    fetchData,
    broadcastMessageClear,
    pushMessage,
    messageTitleChange,
    userSelection,
    questionSelection,
    logout,
    broadcastMessageChange, 
    clearBroadcastText
})(Chat);



// WEBPACK FOOTER //
// ./src/components/Chat/HomePage.js